import { Controller } from "@hotwired/stimulus"

// Fades flash messages out after a few seconds; click dismisses immediately.
export default class extends Controller {
  static values = { delay: { type: Number, default: 4000 } }

  connect() {
    this.timer = setTimeout(() => this.dismiss(), this.delayValue)
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  dismiss() {
    this.element.style.transition = "opacity .4s ease"
    this.element.style.opacity = "0"
    setTimeout(() => this.element.remove(), 400)
  }
}
